import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative py-20 sm:py-28 px-5 sm:px-8">
    <Reveal>
      <div className="relative max-w-6xl mx-auto rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-violet-700 via-violet-800 to-slate-900 px-8 py-16 sm:px-16 sm:py-20 text-center">
        <div className="glow-blob absolute -top-24 left-1/4 w-[420px] h-[420px] rounded-full bg-violet-400/30" />
        <div className="glow-blob absolute -bottom-32 right-0 w-[380px] h-[380px] rounded-full bg-purple-500/25" />
        <div className="relative">
          <span className="uppercase tracking-[0.22em] text-xs font-bold text-violet-200">Heure d'évaluation : 55 €</span>
          <h2 className="font-heading font-black tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight mt-5 max-w-2xl mx-auto">
            Prêt à prendre la route avec Bestconduite78 ?
          </h2>
          <p className="text-violet-100/85 text-sm sm:text-base leading-relaxed mt-5 max-w-xl mx-auto">
            Réservez votre heure d'évaluation avec un moniteur diplômé d'État. Places limitées
            chaque mois dans notre agence de Chatou.
          </p>
          <motion.button
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            data-testid="final-cta-button"
            onClick={() => scrollToId("#contact")}
            className="btn-shine group mt-9 rounded-full bg-white text-violet-800 font-black px-10 py-4 inline-flex items-center gap-2.5 shadow-2xl shadow-black/20"
          >
            Réserver mon évaluation
            <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
          </motion.button>
        </div>
      </div>
    </Reveal>
  </section>
);
